module.exports = __webpack_public_path__ + "static/media/helping-others.e3ba2bdd.png";